import {BrandPanel} from '@/layouts/BrandPanel.jsx'
import styles from './Layout.module.css'

export function Layout({children}) {
  return (
    <div className={styles.page}>
      <main className={styles.card}>
        <BrandPanel/>
        <section className={styles.panel}>
          {children}
        </section>
      </main>
    </div>
  )
}
